import React, { useCallback, useEffect, useState } from "react";
import "./paymentdata.scss";
import baseUrl from "../../../api/baseUrl";
import getDecryptedToken from "../../../api/getDecryptedToken";
import PaymentButton from "../../components/reminder/PayButton";
import { useNavigate } from "react-router-dom";
const initialStartDate = new Date();
const initialEndDate = new Date();
initialEndDate.setMonth(initialEndDate.getMonth() + 1);

function PaymentData() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.payhere.lk/lib/payhere.js";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const navigate = useNavigate();

  const [formData, setformData] = useState({
    price: "",
    clinicName: "",
    title: "",
    lastName: "",
    firstName: "",
    email: "",
    address: "",
    orderId: "",
    phone: "",
    clinicid: "",
    months: 1,
    startDate: initialStartDate,
    endDate: initialEndDate,
  });
  const onChangeHandler = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const { name, value } = e.target;
      const numericValue = parseInt(value);

      if (name === "months") {
        setformData((prevData) => {
          const start = new Date(prevData.startDate);
          const end = new Date(start);
          end.setMonth(end.getMonth() + numericValue);

          return {
            ...prevData,
            months: numericValue,
            endDate: end,
          };
        });
      } else {
        setformData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    },
    []
  );
  useEffect(() => {
    baseUrl
      .get("/client/fee/getClinicPaymentbyId")
      .then((response) => {
        const emp = response?.data?.data;
        if (!emp) {
          console.warn("No payment data found.");
          return;
        }
        setformData((prevData) => {
          console.log(emp);

          const start = new Date(emp.paymentendDate ?? new Date());
          const end = new Date(start);
          end.setMonth(end.getMonth() + 1);
          return {
            ...prevData,
            price: emp?.price || "",
            clinicName: emp?.clinicName || "",
            firstName: emp?.firstName || "",
            lastName: emp?.lastName || "",
            title: emp?.title || "",
            address: emp?.address || "",
            email: emp?.email || "",
            orderId: emp?.orderId || "",
            phone: emp?.phone || "",
            clinicid: emp?.clinicid || "",
            startDate: start,
            endDate: end,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const onNavigate = () => {
    console.log("hi");

    navigate("/dashboard");
  };
  return (
    <div className="payment_data">
      <div className="payment_container">
        <div className="clinic_name">
          <span>clinic name:</span>
          <span>{formData.clinicName}</span>
        </div>
        <p>
          {formData.title + " " + formData.firstName + " " + formData.lastName}
        </p>
        <h3>Your monthly rental is {formData.price}</h3>
        <div className="contant">
          <div>
            <div className="form__group">
              <label className="form__label">
                Select your preferred package
              </label>
              <select
                onChange={onChangeHandler}
                value={formData.months}
                className="form__field"
                name="months"
              >
                {[
                  { name: "1 month", value: 1 },
                  { name: "3 months", value: 3 },
                  { name: "6 months", value: 6 },
                ].map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="fee_table">
              <div className="t_data">
                <div>Total</div>
                <div>{Number(formData.price) * formData.months}</div>
              </div>
              <div className="t_data">
                <div>from</div>
                <div>{formData.startDate.toLocaleDateString()}</div>
              </div>
              <div className="t_data">
                <div>Valid till</div>
                <div>{formData.endDate.toLocaleDateString()}</div>
              </div>
            </div>
            <div className="rem_btn">
              <button onClick={onNavigate}>Cancel Payment</button>
              <PaymentButton formData={formData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentData;
